import { isString } from 'lodash';
export default function useHelpers() {
	const handleString = (val: any) => {
		return isString(val) ? val : undefined;
	};

	return { handleString };
}
